export const GET_SYMPTOMS = 'GET_SYMPTOMS';
export const GET_SYMPTOMS_SUCCESS = 'GET_SYMPTOMS_SUCCESS';
export const GET_SYMPTOMS_FAILED = 'GET_SYMPTOMS_FAILED';

export const SET_STEP_ONE_SELECTED_DISEASE = 'SET_STEP_ONE_SELECTED_DISEASE';
export const SET_STEP_TWO_SELECTED_DISEASE = 'SET_STEP_TWO_SELECTED_DISEASE';

export const DIAGNOSE_DISEASE = 'DIAGNOSE_DISEASE';
export const DIAGNOSE_DISEASE_FAILED = 'DIAGNOSE_DISEASE_FAILED';
export const DIAGNOSE_DISEASE_SUCCESS_GOTO_STEP_TWO =
  'DIAGNOSE_DISEASE_SUCCESS_GOTO_STEP_TWO';
export const DIAGNOSE_DISEASE_SUCCESS_WITH_RESULTS =
  'DIAGNOSE_DISEASE_SUCCESS_WITH_RESULTS';

export const SET_DISEASE = 'SET_DISEASE';
export const RESET_STATE = 'RESET_STATE';
export const SET_ACTIVE_STATE = 'SET_ACTIVE_STATE';
